var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElevatorPitchToolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05888 27.9411 0 18 0C8.05887 0 0 8.05888 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#E1EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6833 13.3334C16.0833 12.8917 16.3333 12.3084 16.3333 11.6667C16.3333 10.2834 15.2166 9.16675 13.8333 9.16675C12.45 9.16675 11.3333 10.2834 11.3333 11.6667C11.3333 12.3084 11.5833 12.8917 11.9833 13.3334H15.6833Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 9.16675C19.4916 9.16675 18 10.6584 18 12.5001V22.5001C18 23.4167 17.25 24.1667 16.3333 24.1667C15.4166 24.1667 14.6666 23.4167 14.6666 22.5001H15.5L16.3333 14.1667H11.3333L12.1666 22.5001H13C13 24.3417 14.4916 25.8334 16.3333 25.8334C18.175 25.8334 19.6666 24.3417 19.6666 22.5001V12.5001C19.6666 11.5834 20.4166 10.8334 21.3333 10.8334C22.25 10.8334 23 11.5834 23 12.5001V25.8334H24.6666V12.5001C24.6666 10.6584 23.175 9.16675 21.3333 9.16675ZM13.9916 20.8334H13.675L13.175 15.8334H14.4916L13.9916 20.8334Z",
    fill: "#1570EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevatorPitchToolIcon);
export default __webpack_public_path__ + "static/media/elevatorPitchToolIcon.d44389bfc6ef25487f37da371c381129.svg";
export { ForwardRef as ReactComponent };